/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum flightDirectionEnum {
  OUTBOUND = 'Outbound',
  INBOUND = 'Inbound',
  ROUNDTRIP = 'Roundtrip',
}
